import { render, staticRenderFns } from "./FormOrdenProduccion.vue?vue&type=template&id=304b554a&scoped=true&"
import script from "./FormOrdenProduccion.vue?vue&type=script&lang=js&"
export * from "./FormOrdenProduccion.vue?vue&type=script&lang=js&"
import style0 from "./FormOrdenProduccion.vue?vue&type=style&index=0&id=304b554a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b554a",
  null
  
)

export default component.exports